import React from 'react';
import styled from "styled-components";
import { mobile } from '../responsive';

const Container = styled.div`
    margin-bottom: 10px;
    justify-content: space-between;
`;
const Square = styled.div`
    margin-left: 25px;
    width: 45%;
    height: 100%;
    background-color: #D3D3D3;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid; 
    vertical-align: top;
    display: inline-block;
    padding: 10px;
    margin-top: 10px;
    border-color: #0039a6;
    ${mobile({ width: "80%" })}
`;
const Rectangle = styled.div`
    margin-left: 25px;
    margin-bottom: 10px;
    width: 95%;
    height: 100%;
    background-color: ;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: ; 
    vertical-align: top;
`

const Text = styled.div`
    text-align: left;
    flex: 1;
    height: 100%;
    ${mobile({ alignItem: "center", paddingRight: "10px" })}
`

const Question = styled.div`
  text-decoration: underline;
`

const Title = styled.div`
  text-align: center;
`

const Block = () => {
  return (
    <Container>
        <Rectangle>
          <Text>
            To complete a U-Haul reservation, please visit <a href={'https://www.uhaul.com/Locations/Truck-Rentals-near-Lake-Orion-MI-48362/021511/'}>uhaul.com</a>, call our store during our hours of operation at 248-693-5962, or contact U-Haul Traffic Control at 1-800-GO-UHAUL. 
            <br/> <br/>
            Frequently Asked Questions:
            <br/> <br/>
            <ul><Question>How do U-Haul rental periods work?:</Question>
            For local rentals, the daily rental rate is charged at the beginning of each 24-hours. Therefore, whether you have a truck/trailer for 3 hours or 23 hours, the rental price is the same.</ul>
            <br/><ul><Question>How do I find pricing for U-Haul rentals?:</Question>
            For local rentals, look in the bottom left box for pricing on trucks and trailers that are commonly in our store's inventory. For pricing on a one-way rental, visit <a href={'https://www.uhaul.com/Locations/Truck-Rentals-near-Lake-Orion-MI-48362/021511/'}>uhaul.com</a>.</ul>
            <br/><ul><Question>What does U-Haul mean when they say "preferred pickup location"?:</Question>
            When a U-Haul reservation is made, you are requesting to go to a specific location, depending on availability, U-Haul Traffic Control might call and send you to another location. </ul>
            <br/><ul><Question>Does this U-Haul location do storage, trailer hitch installation, coordinate moving help, refund unused boxes, or have speciality moving boxes?</Question>
            No. As a neighborhood dealer we do none of those listed things. All of those are through corporate U-Haul stores, not neighborhood dealers.</ul>
          </Text>
        </Rectangle>
        <Square><Title>Estimated Pricing for Trucks and Trailers On LOCAL Rentals:</Title> <br/>
          <a href={'https://www.uhaul.com/Truck-Rentals/Cargo-Van/'}>9' Cargo Van:</a> $19.95 per day, $0.59/0.69 per mile, Optional Insurance, Refill Gas<br/>
          <a href={'https://www.uhaul.com/Truck-Rentals/15ft-Moving-Truck/'}>15' Box Truck:</a> $29.95 per day, $0.79/0.99 per mile, Optional Insurance, Refill Gas<br/>
          <a href={'https://www.uhaul.com/Truck-Rentals/20ft-Moving-Truck/'}>20' Box Truck:</a> $39.95 per day, $0.79/0.99 per mile, Optional Insurance, Refill Gas<br/>
          <a href={'https://www.uhaul.com/Truck-Rentals/26ft-Moving-Truck/'}>26' Box Truck:</a> $39.95 per day, $0.79/0.99 per mile, Optional Insurance, Refill Gas<br/>
          <a href={'https://www.uhaul.com/Trailers/5x8-Cargo-Trailer-Rental/AV/'}>5x8 Enclosed Trailer:</a> $18.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/5x9-Utility-Trailer-With-Ramp-Rental/RT/'}>5x9 Utility Trailer with Ramp:</a> $24.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/5x8-Utility-Trailer-Rental/AO/'}>5x8 Utility Trailer:</a> $18.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/6x12-Utility-Trailer-With-Ramp-Rental/HO/'}>6x12 Utility Trailer with Ramp:</a> $34.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/Motorcycle-Trailer-Rental/MT/'}>Motorcycle Trailer:</a> $14.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/Tow-Dolly-Rental/TD/'}>Tow Dolly:</a> $44.95 per day, Optional Insurance<br/>
          <a href={'https://www.uhaul.com/Trailers/Auto-Transport-Rental/AT/'}>Auto Transport Trailer:</a> $54.95 per day, Optional Insurance<br/>
          <br/> Prices listed above are for LOCAL RENTALS ONLY. <br/> Not all trucks and trailers are always available, visit <a href={'https://www.uhaul.com/Locations/Truck-Rentals-near-Lake-Orion-MI-48362/021511/'}>uhaul.com</a> to create a reservation.
        </Square>
        <Square><Title>24 Hour Pick-Up and Drop-Off: </Title> <br/>
          <Question>24/7 U-Haul Truck Pick-Up:</Question> To complete a 24/7 pick-up, please follow these <a href={'https://www.uhaul.com/Share/'}>U-Haul instructions</a>. 
          <br/> <br/>
          <Question>24/7 U-Haul Truck and Trailer Drop-Off:</Question>
          When dropping off after hours, please leave the item in our lot, not blocking our gate, and if there are keys put the keys in the orange box outside our front door.
        </Square>
    </Container>
  )
}

export default Block